// src/app/core/pwa/components/pwa-prompt/pwa-prompt.component.ts

import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PwaService } from '../../services/pwa.service';
import { PwaPromptStatus } from '../../interfaces/pwa.interface';

@Component({
  selector: 'app-pwa-prompt',
  templateUrl: './pwa-prompt.component.html',
  styleUrls: ['./pwa-prompt.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule]
})
export class PwaPromptComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  
  showPrompt = false;
  isInstalling = false;
  
  // Enum para usar no template
  PwaPromptStatus = PwaPromptStatus;

  constructor(private pwaService: PwaService) {}

  ngOnInit(): void {
    this.subscribeToPromptStatus();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Subscreve ao status do prompt
   */
  private subscribeToPromptStatus(): void {
    this.pwaService.promptStatus$
      .pipe(takeUntil(this.destroy$))
      .subscribe(status => {
        this.showPrompt = status === PwaPromptStatus.VISIBLE;
        this.isInstalling = status === PwaPromptStatus.INSTALLING;
      });
  }

  /**
   * Instala o PWA
   */
  async onInstall(): Promise<void> {
    try {
      this.isInstalling = true;
      const outcome = await this.pwaService.showInstallPrompt();
      console.log('PWA installation outcome:', outcome);
    } catch (error) {
      console.error('Error installing PWA:', error);
      this.isInstalling = false;
    }
  }

  /**
   * Descarta o prompt temporariamente
   */
  onDismiss(): void {
    this.pwaService.dismissPrompt();
  }

  /**
   * Descarta o prompt permanentemente
   */
  onClose(): void {
    this.pwaService.permanentlyDismiss();
  }
}
